import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e3f2693e")

_pushScopeId("data-v-e3f2693e")
const _hoisted_1 = { class: "search-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("検索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新規登録")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("クリア")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_input = _resolveComponent("cus-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_cus_table = _resolveComponent("cus-table")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_cus_input, {
          modelValue: _ctx.table.queryForm.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.table.queryForm.name = $event)),
          inputId: "searchTantoNm",
          labelName: "担当者名",
          size: "small",
          onEnterKeyUp: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch(1)))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "search-button",
          type: "primary",
          icon: "el-icon-search",
          size: "mini",
          plain: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSearch(1)))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "add-button",
          type: "primary",
          icon: "el-icon-plus",
          size: "mini",
          plain: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openDialog(_ctx.DialogGenre.Add)))
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "clear-button",
          icon: "el-icon-close",
          size: "mini",
          plain: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleClear()))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_cus_table, {
      table: _ctx.table,
      tableConfig: _ctx.tableConfig,
      currentPage: _ctx.table.queryForm.page,
      "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (_ctx.table.queryForm.page = $event)),
      "page-size": _ctx.table.queryForm.limit,
      "page-sizes": [20, 50, 80, 100],
      onCurrentChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getList())),
      onSizeChange: _ctx.handleSizeChange,
      ref: "tableRef"
    }, {
      append: _withId(() => [
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withId((scope) => [
            _createVNode(_component_el_tooltip, {
              content: "詳細",
              placement: "left",
              effect: "light"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  class: "edit-btn",
                  circle: "",
                  size: "mini",
                  onClick: ($event: any) => (_ctx.openDialog(_ctx.DialogGenre.Edit, scope.row.accountId)),
                  icon: "el-icon-edit",
                  plain: ""
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_tooltip, {
              content: "削除",
              placement: "right",
              effect: "light"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  class: "delete-btn",
                  circle: "",
                  type: "danger",
                  size: "mini",
                  onClick: ($event: any) => (_ctx.handleDelete(scope.row)),
                  icon: "el-icon-delete",
                  plain: ""
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["table", "tableConfig", "currentPage", "page-size", "onSizeChange"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withId(() => [
        _createVNode(_component_Dialog, {
          title: _ctx.dialogTitle,
          operation: _ctx.dialogOperation,
          onSearch: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSearch(_ctx.table.queryForm.page)))
        }, null, 8, ["title", "operation"])
      ]),
      _: 1
    }))
  ]))
})